//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        content: String,
        link: String,
    },
    methods: {
        joinGroup() {
            this.$sendCtmEvtLog('微聊邀请加群点击')
            const url = this.link.indexOf('https') > -1
                ? `/web_page?link=${encodeURIComponent(this.link)}&title=`
                : this.link
            wx.navigateTo({
                url
            })
        },
    },
}
